export enum PurchaseRequestStatus {
  PENDING = 'Pendente',
  ACCEPTED = 'Aceita',
  IN_QUOTATION = 'Em Cotação',
  AWAITING_FOR_APPROVAL = 'Aguardando Aprovação',
  PENDING_INTEGRATION = 'Não completada',
  QUOTED = 'Concluído',
  URGENT = 'Urgente'
}

export enum ProductIntegrationStatus {
  INTEGRATION_FAILED = 'Falha na integração',
  PARTIALLY_INTEGRATED = 'Integrado Parcialmente',
  SUCCESSFULLY_INTEGRATED = 'Integrado com sucesso'
}

export enum UiCapability {
  PURCHASING_CHANGE_BUYER = 'purchasing.changeBuyer',
  PURCHASING_CANCEL_PURCHASE_REQUEST = 'purchasing.cancelPurchaseRequest',
}

export enum PurchaseRequestDetailTab {
  DETAILS = 0,
  ATTACHMENTS = 1
}

export enum LoadState {
  IDLE = 'idle',
  LOADING = 'loading',
  LOADED = 'loaded',
  ERROR = 'error'
}

